// src/data/directoryLoad.js
//
// Record 610 (ruling 259/262). The three reads the claim form needs for "Presented to" and for the officer's office
// address, in ONE place, so the claim page (ClaimFormPanel.js) and the filer's copy at filing (filedCopy.js, ruling
// 271) draw the same form from the same records:
//   directories/{committee}                    the General Chairperson's directory
//   directories/{committee}/locals/{scopeKey}  the Local Chairperson's directory and his seat's office address
//   committees/{committee}                     the letterhead, whose address lines are the GC's office address
// Each is best-effort, exactly like the loads beside it: a refused or absent read gives null, and the form is then
// drawn as it was before Record 610 (no directory to check against, the officer's own profile address).
// firestore.rules: all three are read by provisioned accounts (isProvisioned).
import { doc, getDoc } from 'firebase/firestore';

const s = (v) => (v == null ? '' : String(v).trim());
const read = (db, ...path) => getDoc(doc(db, ...path)).then((d) => (d.exists() ? d.data() : null)).catch(() => null);

export async function loadDirectories(db, committee, scopeKey) {
  const c = s(committee);
  const k = s(scopeKey);
  if (!db || !c) return { gc: null, lc: null, committeeDoc: null };
  // A scopeKey carrying "/" cannot name a document; none does (scope keys are CRAFT|RAILROAD|TERRITORY or LCA ids).
  const [gc, lc, committeeDoc] = await Promise.all([
    read(db, 'directories', c),
    k && k.indexOf('/') === -1 ? read(db, 'directories', c, 'locals', k) : Promise.resolve(null),
    read(db, 'committees', c),
  ]);
  return { gc, lc, committeeDoc };
}
